export const printerTypes = [
  // { label: 'Select Printer Type', value: null },
  { label: 'Thermal Printer', value: 'thermal_printer' },
  { label: 'Non Thermal Printer', value: 'non_thermal_printer' }
]

export const labelSizes = [
  // { label: 'Select Label Size', value: null },
  { label: '1*4 inch/Label(16 labels)', value: '1_4_16_labels' }
]

export const growMethods = [
  { label: 'Soil', value: 'Soil' },
  { label: 'Hydroponic', value: 'Hydroponic' }
]

export const roomTypes = [
  { value: 'Indoor', label: 'Indoor' },
  { value: 'Outdoor', label: 'Outdoor' },
  { label: 'Greenhouse', value: 'Greenhouse' }
]

export const plantStages = [
  { value: 'seedling', label: 'Seedling' },
  { value: 'pre_veg', label: 'Pre-Veg' },
  { value: 'veg', label: 'Veg' },
  { value: 'flower', label: 'Flower' },
  { value: 'drying', label: 'Drying' },
  { value: 'dried', label: 'Dried' },
  { value: 'sold', label: 'Sold' },
  { value: 'destroyed', label: 'Destroyed' },
  { value: 'mother', label: 'Mother' },
  { value: 'male', label: 'Male' }
]

// immature / clone board action
export const immatureBoardActions = [
  {
    label: 'Create Product',
    action: 'redirectToCreateProduct'
  },
  {
    label: 'Change Batch Status',
    action: 'toggleUpdateBatchStatusModal'
  },
  {
    label: 'Change Batch Location',
    action: 'toggleUpdateBatchLocationModal'
  },
  {
    label: 'Change Growth Phase',
    action: 'changeGrowthPhase'
  },
  {
    label: 'Print Labels',
    action: 'redirectToPrintLabel'
  },
  {
    label: 'View Plants',
    action: 'redirectToViewPlants'
  },
  {
    label: 'Edit Batch Details',
    action: 'redirectToEditBatch'
  },
  {
    label: 'Batch Weight Summary',
    action: 'redirectToBatchWeightSummay'
  },
  {
    label: 'Archived Plants',
    action: 'redirectToArchivedPlants'
  },
  {
    label: 'Destroy Batch Plants',
    action: 'destroyBatchPlants'
  }
]

// vegetative board actions
export const vegetativeBoardActions = [
  {
    label: 'Create Product',
    action: 'redirectToCreateProduct'
  },
  {
    label: 'Change Batch Status',
    action: 'toggleUpdateBatchStatusModal'
  },
  {
    label: 'Change Batch Location',
    action: 'toggleUpdateBatchLocationModal'
  },
  {
    label: 'Change Growth Phase',
    action: 'changeGrowthPhase'
  },
  {
    label: 'Print Labels',
    action: 'redirectToPrintLabel'
  },
  {
    label: 'View Plants',
    action: 'redirectToViewPlants'
  },
  {
    label: 'Edit Batch Details',
    action: 'redirectToEditBatch'
  },
  {
    label: 'Batch Weight Summary',
    action: 'redirectToBatchWeightSummay'
  },
  {
    label: 'Archived Plants',
    action: 'redirectToArchivedPlants'
  },
  {
    label: 'Destroy Batch Plants',
    action: 'destroyBatchPlants'
  }
]

// flower board actions
export const floweringBoardActions = [
  {
    label: 'Create Product',
    action: 'redirectToCreateProduct'
  },
  {
    label: 'Change Batch Status',
    action: 'toggleUpdateBatchStatusModal'
  },
  {
    label: 'Change Batch Location',
    action: 'toggleUpdateBatchLocationModal'
  },
  {
    label: 'Change Growth Phase',
    action: 'changeGrowthPhase'
  },
  {
    label: 'Print Labels',
    action: 'redirectToPrintLabel'
  },
  {
    label: 'View Plants',
    action: 'redirectToViewPlants'
  },
  {
    label: 'Edit Batch Details',
    action: 'redirectToEditBatch'
  },
  {
    label: 'Batch Weight Summary',
    action: 'redirectToBatchWeightSummay'
  },
  {
    label: 'Archived Plants',
    action: 'redirectToArchivedPlants'
  },
  {
    label: 'Destroy Batch Plants',
    action: 'destroyBatchPlants'
  }
]

// plant actions
export const batchPlantActions = [
  {
    label: 'Edit Plant',
    action: 'toggleEditPlant'
  },
  {
    label: 'Delete Plant',
    action: 'deleteRecord'
  },
  {
    label: 'Destroy Batch Plants',
    action: 'destroyBatchPlants'
  }
]

// drying board actions
export const dringBoardActions = [
  {
    label: 'Create Product',
    action: 'redirectToCreateProduct'
  },
  {
    label: 'Change Batch Status',
    action: 'toggleUpdateBatchStatusModal'
  },
  {
    label: 'Change Batch Location',
    action: 'toggleUpdateBatchLocationModal'
  },
  {
    label: 'Change Growth Phase',
    action: 'changeGrowthPhase'
  },
  {
    label: 'Print Labels',
    action: 'redirectToPrintLabel'
  },
  {
    label: 'View Plants',
    action: 'redirectToViewPlants'
  },
  {
    label: 'Edit Batch Details',
    action: 'redirectToEditBatch'
  },
  {
    label: 'Batch Weight Summary',
    action: 'redirectToBatchWeightSummay'
  },
  {
    label: 'Archived Plants',
    action: 'redirectToArchivedPlants'
  },
  {
    label: 'Destroy Batch Plants',
    action: 'destroyBatchPlants'
  }
]

// harvest actions
export const harvestActions = [
  {
    label: 'Remove Weight',
    action: 'toggleRemoveWasteModal'
  },
  {
    label: 'Create Package',
    action: 'toggleCreateHarvestModal'
  },
  {
    label: 'Create Package For Lab Testing',
    action: 'toggleCreateHarvestLabModal'
  }
]

export const labTestHarvestBoardActions = [
  {
    label: 'Change Batch Status',
    action: 'toggleUpdateBatchStatusModal'
  },
  {
    label: 'Change Batch Location',
    action: 'toggleUpdateBatchLocationModal'
  },
  {
    label: 'View Plants',
    action: 'redirectToViewPlants'
  },
  {
    label: 'Batch Weight Summary',
    action: 'redirectToBatchWeightSummay'
  },
  {
    label: 'Archived Plants',
    action: 'redirectToArchivedPlants'
  },
  {
    label: 'Destroy Batch Plants',
    action: 'destroyBatchPlants'
  }
]

// package actions
export const packageActions = [
  {
    label: 'Print Label',
    action: null
  },
  {
    label: 'Barcode',
    action: null
  },
  {
    label: 'Update Quantity',
    action: 'togglePackageQtyUpdateModal'
  },
  {
    label: 'Split Packages',
    action: 'toggleSplitPackageModal'
  },
  {
    label: 'Delete Package',
    action: 'deletePackageConfirmBox'
  },
  {
    label: 'Historical Changes',
    action: null
  },
  {
    label: 'Edit Package',
    action: 'editPackageHandler'
  }
]

// batch board options
export const batchBoardOptions = [
  {
    boardName: 'Immature',
    boardIcon: {
      icon: 'HelpCircleIcon',
      isToolTipEnable: false,
      toolTipNote: 'This column is used for Seeds and Pre-Veg plants.'
    },
    modalTitle: 'Immature Plants',
    boardType: 'batch',
    boardItems: 'immature',
    boardDataPayloads: {
      plantStages: ['seedling', 'pre_veg'],
      status: 'active'
    },
    isHaveActions: true,
    boardActions: immatureBoardActions,
    isHaveModal: true,
    modalDataEndPoint: '/batch-plant/${id}/get-plants',
    modalDataPayloads: {
      plantStage: ['seedling', 'pre_veg']
    },
    modalDataExcludePayloads: ['id'],
    modalDataColumns: [
      { columnName: 'Batch Name', value: 'batch.batch_name' },
      { columnName: 'Plant Name', value: 'plant_name' },
      { columnName: 'Batch Number', value: 'batch.batch_number' },
      // { columnName: 'Strain', value: 'batch.strain.name' },
      { columnName: 'Serial Number', value: 'serialNumber' },
      { columnName: 'Growth Phase', value: 'plant_stage', func: 'renderPlantStage', funcParams: ['plant_stage'] },
      { columnName: 'Location', value: 'location.name' }
      // { columnName: 'Plant Tag Number', value: 'tag_no' }
    ]
  },
  {
    boardName: 'Vegetative',
    boardIcon: {
      icon: 'HelpCircleIcon',
      isToolTipEnable: false,
      toolTipNote: 'This column is used for Male, Mother and Vegetative plants.'
    },
    modalTitle: 'Vegetative Plants',
    boardType: 'plant',
    boardItems: 'vegetative',
    boardDataPayloads: {
      plantStages: ['veg', 'mother', 'male'],
      status: 'active'
    },
    isHaveActions: true,
    boardActions: vegetativeBoardActions,
    isHaveModal: true,
    modalDataEndPoint: '/batch-plant/${id}/get-plants',
    modalDataPayloads: {
      plantStage: ['veg', 'mother', 'male']
    },
    modalDataExcludePayloads: ['id'],
    modalDataColumns: [
      { columnName: 'Batch Name', value: 'batch.batch_name' },
      { columnName: 'Plant Name', value: 'plant_name' },
      { columnName: 'Batch Number', value: 'batch.batch_number' },
      // { columnName: 'Strain', value: 'batch.strain.name' },
      { columnName: 'Serial Number', value: 'serialNumber' },
      { columnName: 'Growth Phase', value: 'plant_stage', func: 'renderPlantStage', funcParams: ['plant_stage'] },
      { columnName: 'Location', value: 'location.name' }
      // { columnName: 'Plant Tag Number', value: 'tag_no' }
    ]
  },
  {
    boardName: 'Flowering',
    boardIcon: {
      icon: 'HelpCircleIcon',
      isToolTipEnable: false,
      toolTipNote: 'This column is used for Flower plants.'
    },
    modalTitle: 'Flowering Plants',
    boardType: 'plant',
    boardItems: 'flowering',
    boardDataPayloads: {
      plantStages: ['flower'],
      status: 'active'
    },
    isHaveActions: true,
    boardActions: floweringBoardActions,
    isHaveModal: true,
    modalDataEndPoint: '/batch-plant/${id}/get-plants',
    modalDataPayloads: {
      plantStage: ['flower']
    },
    modalDataExcludePayloads: ['id'],
    modalDataColumns: [
      { columnName: 'Batch Name', value: 'batch.batch_name' },
      { columnName: 'Plant Name', value: 'plant_name' },
      { columnName: 'Batch Number', value: 'batch.batch_number' },
      // { columnName: 'Strain', value: 'batch.strain.name' },
      { columnName: 'Serial Number', value: 'serialNumber' },
      { columnName: 'Growth Phase', value: 'plant_stage', func: 'renderPlantStage', funcParams: ['plant_stage'] },
      { columnName: 'Location', value: 'location.name' }
      // { columnName: 'Plant Tag Number', value: 'tag_no' }
    ]
  },
  {
    boardName: 'Drying/Dried',
    boardIcon: {
      icon: 'HelpCircleIcon',
      isToolTipEnable: false,
      toolTipNote: 'This column is used for Drying and Dried plants.'
    },
    modalTitle: 'Drying/Dried Plants',
    boardType: 'harvest',
    boardItems: 'dryinDried',
    boardDataPayloads: {
      plantStages: ['drying', 'dried'],
      status: 'active',
      drying: 1
    },
    isHaveActions: true,
    boardActions: dringBoardActions,
    isHaveModal: true,
    modalDataEndPoint: '/batch-plant/${id}/get-plants',
    modalDataPayloads: {
      plantStage: ['drying', 'dried']
    },
    modalDataColumns: [
      { columnName: 'Batch Name', value: 'batch.batch_name' },
      { columnName: 'Plant Name', value: 'plant_name' },
      { columnName: 'Batch Number', value: 'batch.batch_number' },
      // { columnName: 'Strain', value: 'batch.strain.name' },
      { columnName: 'Serial Number', value: 'serialNumber' },
      { columnName: 'Growth Phase', value: 'plant_stage', func: 'renderPlantStage', funcParams: ['plant_stage'] },
      { columnName: 'Location', value: 'location.name' }
      // { columnName: 'Plant Tag Number', value: 'tag_no' }
    ]
  }
]
